//PACKS
import React, { useEffect, useState } from "react";
// import { useSpring, animated } from "react-spring";

//COMPONENTS
import MissionCard from "./MissionCard";

//STYLES
import "../styles/mission.scss";

//ASSETS
import { missions } from "../assets/missionList";

export default function Mission(props) {
  //STATE
  const [displayedMissions, setDisplayedMissions] = useState([]);
  const [showAll, setShowAll] = useState(false);

  //ON PROP CHANGE
  useEffect(() => {
    if (props.device !== "desktop") {
      setDisplayedMissions(missions.slice(0, 2));
    } else {
      setDisplayedMissions(missions);
    }
  }, [props]);

  //ON SHOW ALL CHANGE
  useEffect(() => {
    if (showAll) {
      setDisplayedMissions(missions);
    } else if (!showAll && props.device !== "desktop") {
      setDisplayedMissions(missions.slice(0, 2));
    }
  }, [showAll, props]);

  //HANDLER FOR SHOW ALL BUTTON
  function renderShowMoreButton() {
    if (props.device !== "desktop") {
      return (
        <button
          className="missionShowMoreButton"
          onClick={() => {
            setShowAll(!showAll);
          }}
        >
          {showAll ? "Mostra di più" : "Mostra di meno"}
        </button>
      );
    }
  }

  return (
    <div className="missionContainer">
      <div style={{ position: "absolute", top: "-4em" }} id="mission" />
      <div className="missionsGrid">
        <div className="mission" id="missionTitleCard">
          <h2>Our mission</h2>
          <p>
            Fondata nel 2006, opera sul territorio nazionale attraverso una rete
            diffusa di professionalità e competenze che riflette la storia dei
            soci.
          </p>
          <div />
          <p>Gli ambiti di intervento di SET:</p>
        </div>
        {displayedMissions.map((mission, id) => (
          <MissionCard key={id} mission={mission} id={id} />
        ))}
        {renderShowMoreButton()}
      </div>
    </div>
  );
}
